var ke = Object.defineProperty;
var me = (t) => {
  throw TypeError(t);
};
var Ie = (t, n, s) => n in t ? ke(t, n, { enumerable: !0, configurable: !0, writable: !0, value: s }) : t[n] = s;
var W = (t, n, s) => Ie(t, typeof n != "symbol" ? n + "" : n, s), pe = (t, n, s) => n.has(t) || me("Cannot " + s);
var x = (t, n, s) => (pe(t, n, "read from private field"), s ? s.call(t) : n.get(t)), R = (t, n, s) => n.has(t) ? me("Cannot add the same private member more than once") : n instanceof WeakSet ? n.add(t) : n.set(t, s), M = (t, n, s, r) => (pe(t, n, "write to private field"), r ? r.call(t, s) : n.set(t, s), s);
import { j as e } from "./jsx-runtime-B6kdoens.js";
import { i as qe, j as Re, k as Me } from "./utils-DcpDOncX.js";
import { XIcon as Ae, EraserIcon as Se, ChevronsUpDownIcon as Ve, LogInIcon as ze, CirclePlayIcon as Fe } from "lucide-react";
import { u as Le } from "./hook-hEqe7fPB.js";
import { Button as E } from "./ui/Button.js";
import { initializeWorker as De } from "zudoku/openapi-worker";
import { Z as Ge } from "./invariant-Caa8-XvF.js";
import { VisuallyHidden as Be } from "@radix-ui/react-visually-hidden";
import * as he from "react";
import { useRef as Ce, useEffect as $e, useState as Te, useTransition as Je, Fragment as Z } from "react";
import { D as He, b as Qe, a as Ue, c as We } from "./Dialog-k70Qfukb.js";
import { u as Ze, S as fe, a as xe, b as ye, c as ge, e as K } from "./Select-O9ZM3ZgX.js";
import { b as oe, C as $, u as Ke, a as Xe, F as Ye } from "./index.esm-C5mr_sKO.js";
import { a as et } from "./state-tsXBLONe.js";
import { S as ve } from "./Spinner-3cQDBVGr.js";
import { Callout as tt } from "./ui/Callout.js";
import { Card as ae, CardHeader as nt, CardTitle as st, CardContent as rt } from "./ui/Card.js";
import { Tabs as je, TabsList as be, TabsTrigger as A, TabsContent as V } from "./ui/Tabs.js";
import { z as at, S as ot } from "./SyntaxHighlight-DkLOsjHS.js";
import { c as P } from "./cn-BmFQLtkS.js";
import { Input as H } from "./ui/Input.js";
import { Slot as it } from "@radix-ui/react-slot";
import { m as lt } from "./router-lfyopgBI.js";
class L extends String {
  constructor(s, r) {
    super(s);
    W(this, "__apiType");
    this.value = s, this.__meta__ = r;
  }
  toString() {
    return this.value;
  }
}
const ct = new L(
  `
    fragment OperationsFragment on OperationItem {
  slug
  summary
  method
  description
  operationId
  contentTypes
  path
  parameters {
    name
    in
    description
    required
    schema
    style
    examples {
      name
      description
      externalValue
      value
      summary
    }
  }
  requestBody {
    content {
      mediaType
      encoding {
        name
      }
      examples {
        name
        description
        externalValue
        value
        summary
      }
      schema
    }
    description
    required
  }
  responses {
    statusCode
    links
    description
    content {
      examples {
        name
        description
        externalValue
        value
        summary
      }
      mediaType
      encoding {
        name
      }
      schema
    }
  }
}
    `,
  { fragmentName: "OperationsFragment" }
), dt = new L(`
    query ServersQuery($input: JSON!, $type: SchemaType!) {
  schema(input: $input, type: $type) {
    url
    servers {
      url
    }
  }
}
    `), ut = new L(`
    query AllOperations($input: JSON!, $type: SchemaType!) {
  schema(input: $input, type: $type) {
    description
    title
    url
    version
    tags {
      name
      description
      operations {
        slug
        ...OperationsFragment
      }
    }
  }
}
    fragment OperationsFragment on OperationItem {
  slug
  summary
  method
  description
  operationId
  contentTypes
  path
  parameters {
    name
    in
    description
    required
    schema
    style
    examples {
      name
      description
      externalValue
      value
      summary
    }
  }
  requestBody {
    content {
      mediaType
      encoding {
        name
      }
      examples {
        name
        description
        externalValue
        value
        summary
      }
      schema
    }
    description
    required
  }
  responses {
    statusCode
    links
    description
    content {
      examples {
        name
        description
        externalValue
        value
        summary
      }
      mediaType
      encoding {
        name
      }
      schema
    }
  }
}`), mt = new L(`
    query getServerQuery($input: JSON!, $type: SchemaType!) {
  schema(input: $input, type: $type) {
    url
    servers {
      url
    }
  }
}
    `), pt = new L(`
    query GetCategories($input: JSON!, $type: SchemaType!) {
  schema(input: $input, type: $type) {
    url
    tags {
      __typename
      name
      operations {
        __typename
        slug
        deprecated
        method
        summary
        operationId
        path
      }
    }
  }
}
    `), ht = {
  "\n  query ServersQuery($input: JSON!, $type: SchemaType!) {\n    schema(input: $input, type: $type) {\n      url\n      servers {\n        url\n      }\n    }\n  }\n": dt,
  "\n  fragment OperationsFragment on OperationItem {\n    slug\n    summary\n    method\n    description\n    operationId\n    contentTypes\n    path\n    parameters {\n      name\n      in\n      description\n      required\n      schema\n      style\n      examples {\n        name\n        description\n        externalValue\n        value\n        summary\n      }\n    }\n    requestBody {\n      content {\n        mediaType\n        encoding {\n          name\n        }\n        examples {\n          name\n          description\n          externalValue\n          value\n          summary\n        }\n        schema\n      }\n      description\n      required\n    }\n    responses {\n      statusCode\n      links\n      description\n      content {\n        examples {\n          name\n          description\n          externalValue\n          value\n          summary\n        }\n        mediaType\n        encoding {\n          name\n        }\n        schema\n      }\n    }\n  }\n": ct,
  "\n  query AllOperations($input: JSON!, $type: SchemaType!) {\n    schema(input: $input, type: $type) {\n      description\n      title\n      url\n      version\n      tags {\n        name\n        description\n        operations {\n          slug\n          ...OperationsFragment\n        }\n      }\n    }\n  }\n": ut,
  "\n  query getServerQuery($input: JSON!, $type: SchemaType!) {\n    schema(input: $input, type: $type) {\n      url\n      servers {\n        url\n      }\n    }\n  }\n": mt,
  "\n  query GetCategories($input: JSON!, $type: SchemaType!) {\n    schema(input: $input, type: $type) {\n      url\n      tags {\n        __typename\n        name\n        operations {\n          __typename\n          slug\n          deprecated\n          method\n          summary\n          operationId\n          path\n        }\n      }\n    }\n  }\n": pt
};
function ft(t) {
  return ht[t] ?? {};
}
function X(t) {
  if (!ie(t))
    throw new Error("Parameter was not an error");
}
function ie(t) {
  return !!t && typeof t == "object" && xt(t) === "[object Error]" || t instanceof Error;
}
function xt(t) {
  return Object.prototype.toString.call(t);
}
const yt = "Layerr";
let gt = yt;
function vt() {
  return gt;
}
function jt(t) {
  let n, s = "";
  if (t.length === 0)
    n = {};
  else if (ie(t[0]))
    n = {
      cause: t[0]
    }, s = t.slice(1).join(" ") || "";
  else if (t[0] && typeof t[0] == "object")
    n = Object.assign({}, t[0]), s = t.slice(1).join(" ") || "";
  else if (typeof t[0] == "string")
    n = {}, s = s = t.join(" ") || "";
  else
    throw new Error("Invalid arguments passed to Layerr");
  return {
    options: n,
    shortMessage: s
  };
}
class y extends Error {
  constructor(n, s) {
    const r = [...arguments], { options: o, shortMessage: l } = jt(r);
    let i = l;
    if (o.cause && (i = `${i}: ${o.cause.message}`), super(i), this.message = i, o.name && typeof o.name == "string" ? this.name = o.name : this.name = vt(), o.cause && Object.defineProperty(this, "_cause", { value: o.cause }), Object.defineProperty(this, "_info", { value: {} }), o.info && typeof o.info == "object" && Object.assign(this._info, o.info), Error.captureStackTrace) {
      const c = o.constructorOpt || this.constructor;
      Error.captureStackTrace(this, c);
    }
  }
  static cause(n) {
    return X(n), n._cause && ie(n._cause) ? n._cause : null;
  }
  static fullStack(n) {
    X(n);
    const s = y.cause(n);
    return s ? `${n.stack}
caused by: ${y.fullStack(s)}` : n.stack ?? "";
  }
  static info(n) {
    X(n);
    const s = {}, r = y.cause(n);
    return r && Object.assign(s, y.info(r)), n._info && Object.assign(s, n._info), s;
  }
  toString() {
    let n = this.name || this.constructor.name || this.constructor.prototype.name;
    return this.message && (n = `${n}: ${this.message}`), n;
  }
}
const Ee = "0123456789ABCDEFGHJKMNPQRSTVWXYZ", F = 32, Ne = 281474976710655, bt = 10, Nt = 16, z = Object.freeze({
  source: "ulid"
});
function wt(t) {
  const n = St(), s = n && (n.crypto || n.msCrypto) || null;
  if (typeof (s == null ? void 0 : s.getRandomValues) == "function")
    return () => {
      const r = new Uint8Array(1);
      return s.getRandomValues(r), r[0] / 255;
    };
  if (typeof (s == null ? void 0 : s.randomBytes) == "function")
    return () => s.randomBytes(1).readUInt8() / 255;
  throw new y({
    info: {
      code: "PRNG_DETECT",
      ...z
    }
  }, "Failed to find a reliable PRNG");
}
function St() {
  return Tt() ? self : typeof window < "u" ? window : typeof global < "u" ? global : typeof globalThis < "u" ? globalThis : null;
}
function Ct(t, n) {
  let s = "";
  for (; t > 0; t--)
    s = Et(n) + s;
  return s;
}
function $t(t, n) {
  if (isNaN(t))
    throw new y({
      info: {
        code: "ENC_TIME_NAN",
        ...z
      }
    }, `Time must be a number: ${t}`);
  if (t > Ne)
    throw new y({
      info: {
        code: "ENC_TIME_SIZE_EXCEED",
        ...z
      }
    }, `Cannot encode a time larger than ${Ne}: ${t}`);
  if (t < 0)
    throw new y({
      info: {
        code: "ENC_TIME_NEG",
        ...z
      }
    }, `Time must be positive: ${t}`);
  if (Number.isInteger(t) === !1)
    throw new y({
      info: {
        code: "ENC_TIME_TYPE",
        ...z
      }
    }, `Time must be an integer: ${t}`);
  let s, r = "";
  for (let o = n; o > 0; o--)
    s = t % F, r = Ee.charAt(s) + r, t = (t - s) / F;
  return r;
}
function Tt() {
  return typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope;
}
function Et(t) {
  let n = Math.floor(t() * F);
  return n === F && (n = F - 1), Ee.charAt(n);
}
function Pt(t, n) {
  const s = wt(), r = isNaN(t) ? Date.now() : t;
  return $t(r, bt) + Ct(Nt, s);
}
let Y, ee;
const te = (t) => {
  var n;
  if ((n = t.errors) != null && n[0])
    throw new Ge(t.errors[0].message, {
      developerHint: "Check your configuration value `apis.type` and `apis.input` in the Zudoku config."
    });
};
var T, O, N, Q;
class Ot {
  constructor(n) {
    R(this, T);
    R(this, O, /* @__PURE__ */ new Map());
    R(this, N);
    R(this, Q, () => import("./createServer-DizTyrsZ.js").then((n) => n.createServer()));
    W(this, "fetch", async (n, ...[s]) => {
      var l;
      const r = (l = n.match(/query (\w+)/)) == null ? void 0 : l[1], o = JSON.stringify({ query: n, variables: s, operationName: r });
      switch (x(this, T)) {
        case "remote": {
          const i = await fetch(this.config.server, {
            method: "POST",
            body: o,
            headers: { "Content-Type": "application/json" }
          });
          if (!i.ok)
            throw new Error("Network response was not ok");
          const c = await i.json();
          return te(c), c.data;
        }
        case "in-memory": {
          Y || (Y = x(this, Q).call(this));
          const i = await Y;
          if (!i) throw new Error("Local server not initialized");
          const c = await i.fetch(
            new Request("http://localhost/graphql", {
              method: "POST",
              body: o,
              headers: { "Content-Type": "application/json" }
            })
          );
          if (!c.ok)
            throw new Error("Network response was not ok");
          const u = await c.json();
          return te(u), u.data;
        }
        case "worker": {
          if (ee || (ee = De()), !x(this, N)) {
            const d = new MessageChannel();
            ee.port.postMessage({ port: d.port2 }, [d.port2]), M(this, N, d.port1), x(this, N).onmessage = (h) => {
              const { id: g, body: j } = h.data, b = x(this, O).get(g);
              if (b) {
                const w = JSON.parse(j);
                b(w), x(this, O).delete(g);
              } else
                console.error(`No pending request found for id: ${g}`);
            }, x(this, N).start();
          }
          const i = Pt(), u = await new Promise(
            (d) => {
              x(this, O).set(i, d), x(this, N).postMessage({ id: i, body: o });
            }
          );
          return te(u), u.data;
        }
      }
    });
    this.config = n, n.server ? M(this, T, "remote") : n.inMemory || typeof SharedWorker > "u" ? M(this, T, "in-memory") : M(this, T, "worker");
  }
}
T = new WeakMap(), O = new WeakMap(), N = new WeakMap(), Q = new WeakMap();
const ne = (t) => Math.abs(
  isNaN(parseInt(t)) ? t.toLowerCase().charCodeAt(0) - 96 : isNaN(parseInt(t)) ? 0 : parseInt(t)
), se = (t) => t.length > 1 ? parseInt(t.split("").reduce((n, s) => `${ne(n) + ne(s)}`)) : ne(t), _t = (t, n = {}) => {
  const s = (3 * se(t) + 2 * se(t) + se(t)) % 360, { saturation: r = 75, lightness: o = 60 } = n;
  return `${s}deg ${r}% ${o}%`;
}, re = "data-linked-param", kt = (t) => {
  const { resolvedTheme: n } = at();
  return _t(
    t,
    n === "light" ? { saturation: 85, lightness: 50 } : void 0
  );
}, Pe = ({
  name: t,
  className: n,
  backgroundOpacity: s = "100%",
  borderOpacity: r = "100%",
  slug: o,
  children: l,
  onClick: i
}) => {
  const c = Ce(null), u = t.replace(/[{}]/g, ""), d = o == null ? void 0 : o.replace(/[{}]/g, ""), h = kt(u), g = `hsl(${h} / ${r})`, j = `hsl(${h} / ${s})`;
  return $e(() => {
    if (!d || !c.current) return;
    const b = () => {
      document.querySelectorAll(`[${re}="${d}"]`).forEach((S) => {
        S instanceof HTMLElement && (S.dataset.active = "true");
      });
    }, w = () => {
      document.querySelectorAll(`[${re}="${d}"]`).forEach((S) => {
        S instanceof HTMLElement && (S.dataset.active = "false");
      });
    }, v = c.current;
    return v.addEventListener("mouseenter", b), v.addEventListener("mouseleave", w), () => {
      v.removeEventListener("mouseenter", b), v.removeEventListener("mouseleave", w);
    };
  }, [d]), /* @__PURE__ */ e.jsx(
    "span",
    {
      [re]: d,
      className: P(
        "relative after:rounded after:absolute after:inset-0 after:-bottom-0.5 after:border-b-2 after:transition-opacity after:duration-200",
        "after:pointer-events-none after:border-[--border-color] after:opacity-30 after:data-[active=true]:opacity-100",
        n
      ),
      suppressHydrationWarning: !0,
      ref: c,
      onClick: i,
      style: {
        "--border-color": g,
        "--background-color": j
      },
      children: l ?? t
    }
  );
}, It = (t, n, s) => {
  const r = n.replace(/(:\w+|\{\w+})/g, (l) => {
    var u;
    const i = l.replace(/[:{}]/g, "");
    return ((u = s.pathParams.find((d) => d.name === i)) == null ? void 0 : u.value) ?? l;
  }), o = new URL(
    r.replace(/^\//, ""),
    t.endsWith("/") ? t : `${t}/`
  );
  return s.queryParams.filter((l) => l.active).forEach((l) => {
    o.searchParams.set(l.name, l.value);
  }), o;
}, qt = ({
  control: t,
  register: n
}) => {
  const { fields: s, append: r, remove: o } = oe({
    control: t,
    name: "headers"
  });
  return /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ e.jsx("table", { className: "w-full [&_td]:border [&_td]:p-1.5 [&_td]:px-2", children: /* @__PURE__ */ e.jsx("tbody", { children: s.map((l, i) => /* @__PURE__ */ e.jsxs(
      "tr",
      {
        className: "group has-[:focus]:bg-muted/50 hover:bg-muted/50",
        children: [
          /* @__PURE__ */ e.jsx("td", { className: "flex gap-2 items-center", children: /* @__PURE__ */ e.jsx(
            H,
            {
              ...n(`headers.${i}.name`),
              placeholder: "Name",
              className: "border-0 shadow-none text-xs font-mono",
              autoComplete: "off"
            }
          ) }),
          /* @__PURE__ */ e.jsx("td", { children: /* @__PURE__ */ e.jsxs("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ e.jsx(
              H,
              {
                placeholder: "Value",
                className: "border-0 shadow-none text-xs font-mono",
                ...n(`headers.${i}.value`),
                autoComplete: "off"
              }
            ),
            /* @__PURE__ */ e.jsx(
              E,
              {
                size: "icon",
                variant: "ghost",
                className: "text-muted-foreground opacity-0 group-hover:opacity-100",
                onClick: () => {
                  o(i);
                },
                type: "button",
                children: /* @__PURE__ */ e.jsx(Ae, { size: 16 })
              }
            )
          ] }) })
        ]
      },
      l.id
    )) }) }),
    /* @__PURE__ */ e.jsx("div", { className: "text-end", children: /* @__PURE__ */ e.jsx(
      E,
      {
        className: "",
        onClick: () => r({ name: "", value: "" }),
        type: "button",
        children: "Add header"
      }
    ) })
  ] });
}, Rt = ({
  control: t
}) => {
  const { fields: n } = oe({
    control: t,
    name: "pathParams"
  });
  return /* @__PURE__ */ e.jsx("table", { className: "w-full table-auto [&_td]:border [&_td]:py-1 [&_td]:px-2", children: /* @__PURE__ */ e.jsx("tbody", { children: n.map((s, r) => /* @__PURE__ */ e.jsxs("tr", { className: "hover:bg-accent/40", children: [
    /* @__PURE__ */ e.jsx("td", { children: /* @__PURE__ */ e.jsx(
      $,
      {
        control: t,
        name: `pathParams.${r}.value`,
        render: ({ field: o }) => /* @__PURE__ */ e.jsxs("div", { children: [
          /* @__PURE__ */ e.jsx(
            Pe,
            {
              slug: s.name,
              name: s.name,
              backgroundOpacity: "25%",
              borderOpacity: o.value ? "100%" : "0",
              className: P(
                "font-mono text-xs m-2",
                !o.value && "opacity-60"
              )
            }
          ),
          "*"
        ] })
      }
    ) }),
    /* @__PURE__ */ e.jsx("td", { children: /* @__PURE__ */ e.jsxs("div", { className: "flex justify-between items-center", children: [
      /* @__PURE__ */ e.jsx(
        $,
        {
          control: t,
          name: `pathParams.${r}.value`,
          render: ({ field: o }) => /* @__PURE__ */ e.jsx(
            H,
            {
              ...o,
              placeholder: "Enter value",
              className: "border-0 shadow-none ring-0 font-mono text-xs"
            }
          )
        }
      ),
      /* @__PURE__ */ e.jsx(
        $,
        {
          control: t,
          name: `pathParams.${r}.value`,
          render: ({ field: o }) => /* @__PURE__ */ e.jsx(
            E,
            {
              size: "icon",
              type: "button",
              variant: "ghost",
              "aria-label": "Clear value",
              className: P(
                "ms-2",
                o.value.length === 0 ? "opacity-0 pointer-events-none" : "opacity-100"
              ),
              title: "Clear value",
              onClick: () => o.onChange(""),
              children: /* @__PURE__ */ e.jsx(Se, { size: 16 })
            }
          )
        }
      )
    ] }) })
  ] }, s.id)) }) });
}, Mt = (t, n) => {
  const s = he.forwardRef(({ className: r, asChild: o, ...l }, i) => {
    const c = o ? it : t;
    return he.createElement(c, {
      ...l,
      ref: i,
      className: P(n, r)
    });
  });
  return s.displayName = `VariantComponent(${t})`, s;
}, At = Mt(
  "input",
  "px-2 bg-transparent h-6 font-mono text-xs m-2"
), Vt = ({
  control: t,
  queryParams: n
}) => {
  const { fields: s } = oe({
    control: t,
    name: "queryParams"
  }), r = Ke(), o = n.map((c) => !!c.isRequired), i = r.watch("identity") !== J;
  return /* @__PURE__ */ e.jsx("div", { className: "", children: /* @__PURE__ */ e.jsx("table", { className: "w-full [&_td]:border [&_td]:p-1.5 [&_td]:px-2", children: /* @__PURE__ */ e.jsx("tbody", { children: s.filter(
    // TODO remove this hack for Accu or make it more generic
    (c) => !(i && c.name === "apikey")
  ).map((c, u) => /* @__PURE__ */ e.jsxs("tr", { className: "hover:bg-accent/40", children: [
    /* @__PURE__ */ e.jsx("td", { className: "text-center", children: /* @__PURE__ */ e.jsx(
      $,
      {
        control: t,
        name: `queryParams.${u}.active`,
        render: ({ field: d }) => /* @__PURE__ */ e.jsx(
          "input",
          {
            type: "checkbox",
            id: `queryParams.${u}.active`,
            checked: d.value,
            onChange: d.onChange
          }
        )
      }
    ) }),
    /* @__PURE__ */ e.jsx("td", { children: /* @__PURE__ */ e.jsx(
      $,
      {
        control: t,
        render: ({ field: d }) => /* @__PURE__ */ e.jsx(At, { asChild: !0, children: /* @__PURE__ */ e.jsxs(
          "label",
          {
            className: "flex items-center cursor-pointer",
            htmlFor: `queryParams.${u}.active`,
            title: o[u] ? "Required field" : void 0,
            children: [
              d.value,
              o[u] && /* @__PURE__ */ e.jsx("sup", { children: " *" })
            ]
          }
        ) }),
        name: `queryParams.${u}.name`
      }
    ) }),
    /* @__PURE__ */ e.jsx("td", { children: /* @__PURE__ */ e.jsxs("div", { className: "flex justify-between items-center", children: [
      /* @__PURE__ */ e.jsx(
        $,
        {
          control: t,
          render: ({ field: d }) => /* @__PURE__ */ e.jsx(
            H,
            {
              ...d,
              onChange: (h) => {
                d.onChange(h.target.value), h.target.value.length > 0 && r.setValue(`queryParams.${u}.active`, !0);
              },
              placeholder: "Enter value",
              className: "w-full border-0 shadow-none text-xs font-mono"
            }
          ),
          name: `queryParams.${u}.value`
        }
      ),
      /* @__PURE__ */ e.jsx(
        $,
        {
          control: t,
          render: ({ field: d }) => /* @__PURE__ */ e.jsx(
            E,
            {
              size: "icon",
              type: "button",
              variant: "ghost",
              "aria-label": "Clear value",
              className: P(
                "ms-2",
                d.value.length === 0 ? "opacity-0 pointer-events-none" : "opacity-100"
              ),
              title: "Clear value",
              onClick: () => d.onChange(""),
              children: /* @__PURE__ */ e.jsx(Se, { size: 16 })
            }
          ),
          name: `queryParams.${u}.value`
        }
      )
    ] }) })
  ] }, c.id)) }) }) });
}, zt = ({
  value: t,
  onChange: n,
  className: s,
  options: r,
  showChevrons: o = !0
}) => /* @__PURE__ */ e.jsxs("div", { className: "grid", children: [
  /* @__PURE__ */ e.jsx(
    "select",
    {
      className: P(
        "row-start-1 col-start-1 border border-input text-foreground px-2 py-1 pe-6",
        "rounded-md appearance-none bg-zinc-50 hover:bg-white dark:bg-zinc-800 hover:dark:bg-zinc-800/75",
        s
      ),
      value: t,
      onChange: n,
      children: r.map((l) => /* @__PURE__ */ e.jsx("option", { value: l.value, children: l.label }, l.value))
    }
  ),
  /* @__PURE__ */ e.jsx(
    "div",
    {
      className: P(
        !o && "hidden",
        "row-start-1 col-start-1 self-center justify-self-end relative end-2 pointer-events-none"
      ),
      children: /* @__PURE__ */ e.jsx(Ve, { size: 14 })
    }
  )
] }), Ft = (t) => {
  var s;
  return (s = Object.entries({
    "application/json": "json",
    "text/json": "json",
    "text/html": "html",
    "text/css": "css",
    "text/javascript": "javascript",
    "application/xml": "xml",
    "application/xhtml+xml": "xhtml"
  }).find(
    ([r]) => t.includes(r)
  )) == null ? void 0 : s[1];
}, Lt = (t) => {
  const n = t.get("Content-Type") || "";
  return Ft(n);
}, Dt = (t) => {
  try {
    return JSON.stringify(JSON.parse(t), null, 2);
  } catch {
    return null;
  }
}, Gt = ({
  body: t = "",
  headers: n
}) => {
  const s = Lt(n), r = Dt(t), o = r || t, [l, i] = Te(
    r ? "formatted" : "raw"
  );
  return /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ e.jsx(ae, { className: "shadow-none", children: /* @__PURE__ */ e.jsx(
      ot,
      {
        language: l === "raw" ? r ? "plain" : s : "json",
        noBackground: !0,
        className: "overflow-x-auto p-4 text-xs max-h-[calc(83.333vh-180px)]",
        code: l === "raw" ? t : o
      }
    ) }),
    r && /* @__PURE__ */ e.jsx("div", { className: "flex justify-end", children: /* @__PURE__ */ e.jsx(
      zt,
      {
        value: l,
        onChange: (c) => i(c.target.value),
        options: [
          { value: "formatted", label: "Formatted" },
          { value: "raw", label: "Raw" }
        ]
      }
    ) })
  ] });
}, J = "__none", Bt = {
  200: "OK",
  201: "Created",
  202: "Accepted",
  204: "No Content",
  400: "Bad Request",
  401: "Unauthorized",
  403: "Forbidden",
  404: "Not Found",
  405: "Method Not Allowed",
  500: "Internal Server Error"
}, Jt = ({
  server: t,
  servers: n,
  url: s,
  method: r,
  headers: o = [],
  queryParams: l = [],
  pathParams: i = [],
  defaultBody: c = ""
}) => {
  var de, ue;
  const { selectedServer: u, setSelectedServer: d } = et(), [, h] = Je(), { register: g, control: j, handleSubmit: b, watch: w, setValue: v, ...S } = Xe({
    defaultValues: {
      body: c,
      queryParams: l.map((a) => ({
        name: a.name,
        value: a.defaultValue ?? "",
        active: a.defaultActive ?? !1
      })),
      pathParams: i.map((a) => ({
        name: a.name,
        value: a.defaultValue ?? ""
      })),
      headers: o.map((a) => ({
        name: a.name,
        value: a.defaultValue ?? ""
      })),
      identity: J
    }
  }), C = w(), _ = qe(), le = Ce(!1);
  $e(() => {
    var f;
    if (le.current) return;
    const a = (f = _.data) == null ? void 0 : f.at(0);
    a && (v("identity", a.id), le.current = !0);
  }, [v, _.data]);
  const p = Ze({
    mutationFn: async (a) => {
      var I, q;
      const f = It(u ?? t, s, a), k = performance.now(), D = new Request(f, {
        method: r.toUpperCase(),
        headers: Object.fromEntries(
          a.headers.filter((m) => m.name).map((m) => [m.name, m.value])
        ),
        body: a.body ? a.body : void 0
      });
      a.identity !== J && ((q = (I = _.data) == null ? void 0 : I.find((m) => m.id === a.identity)) == null || q.authorizeRequest(D));
      try {
        const m = await fetch(D, {
          signal: AbortSignal.timeout(5e3)
        }), G = performance.now() - k, B = await m.text();
        return {
          status: m.status,
          headers: m.headers,
          size: B.length,
          body: B,
          time: G
        };
      } catch (m) {
        throw m instanceof TypeError ? new Error(
          "The request failed, possibly due to network issues or CORS policy."
        ) : m;
      }
    }
  }), Oe = s.split("/").map((a, f, k) => {
    var G;
    const D = a.startsWith("{") && a.endsWith("}") || a.startsWith(":"), I = a.replace(/[:{}]/g, ""), q = (G = C.pathParams.find((B) => B.name === I)) == null ? void 0 : G.value, m = q ? /* @__PURE__ */ e.jsx(Pe, { backgroundOpacity: "25%", name: a, slug: a, children: encodeURIComponent(q) }) : /* @__PURE__ */ e.jsx(
      "span",
      {
        className: "underline decoration-wavy decoration-red-500",
        title: `Missing value for path parameter \`${I}\``,
        children: a
      }
    );
    return (
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ e.jsxs(Z, { children: [
        D ? m : a,
        f < k.length - 1 && "/",
        /* @__PURE__ */ e.jsx("wbr", {})
      ] }, a + f)
    );
  }), U = Array.from(((de = p.data) == null ? void 0 : de.headers.entries()) ?? []), ce = C.queryParams.filter((a) => a.active).map((a, f, k) => /* @__PURE__ */ e.jsxs(Z, { children: [
    a.name,
    "=",
    encodeURIComponent(a.value).replaceAll("%20", "+"),
    f < k.length - 1 && "&",
    /* @__PURE__ */ e.jsx("wbr", {})
  ] }, a.name)), _e = /* @__PURE__ */ e.jsx("div", { className: "inline-block opacity-50 hover:opacity-100 transition", children: n && n.length > 1 ? /* @__PURE__ */ e.jsxs(
    fe,
    {
      onValueChange: (a) => {
        h(() => {
          d(a);
        });
      },
      value: u,
      children: [
        /* @__PURE__ */ e.jsx(xe, { className: "p-0 border-none flex-row-reverse bg-transparent text-xs gap-0.5 h-auto", children: /* @__PURE__ */ e.jsx(ye, {}) }),
        /* @__PURE__ */ e.jsx(ge, { children: n.map((a) => /* @__PURE__ */ e.jsx(K, { value: a, children: a.replace(/^https?:\/\//, "") }, a)) })
      ]
    }
  ) : /* @__PURE__ */ e.jsx("span", { children: t.replace(/^https?:\/\//, "") }) });
  return /* @__PURE__ */ e.jsx(
    Ye,
    {
      register: g,
      control: j,
      handleSubmit: b,
      watch: w,
      setValue: v,
      ...S,
      children: /* @__PURE__ */ e.jsx("form", { onSubmit: b((a) => p.mutateAsync(a)), children: /* @__PURE__ */ e.jsxs("div", { className: "grid grid-cols-[8fr_7fr] text-sm h-full", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-4 p-8 bg-muted/50 after:bg-muted-foreground/20 relative after:absolute after:w-px after:inset-0 after:left-auto", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flex gap-2 items-stretch", children: [
            /* @__PURE__ */ e.jsxs("div", { className: "flex flex-1 items-center w-full border rounded-md", children: [
              /* @__PURE__ */ e.jsx("div", { className: "border-r p-2 bg-muted rounded-l-md self-stretch font-semibold font-mono", children: r.toUpperCase() }),
              /* @__PURE__ */ e.jsxs("div", { className: "flex items-center flex-wrap p-2 font-mono text-xs", children: [
                _e,
                Oe,
                ce.length > 0 ? "?" : "",
                ce
              ] })
            ] }),
            /* @__PURE__ */ e.jsx(E, { type: "submit", className: "h-auto flex gap-1", children: "Send" })
          ] }),
          /* @__PURE__ */ e.jsxs(
            je,
            {
              defaultValue: l.length + i.length > 0 ? "parameters" : "headers",
              children: [
                /* @__PURE__ */ e.jsxs("div", { className: "flex flex-wrap gap-1 justify-between", children: [
                  /* @__PURE__ */ e.jsxs(be, { children: [
                    l.length + i.length > 0 && /* @__PURE__ */ e.jsx(A, { value: "parameters", children: "Parameters" }),
                    /* @__PURE__ */ e.jsxs(A, { value: "headers", children: [
                      "Headers",
                      " ",
                      C.headers.length > 0 && `(${C.headers.length})`
                    ] }),
                    /* @__PURE__ */ e.jsx(
                      A,
                      {
                        value: "body",
                        disabled: !["POST", "PUT", "PATCH", "DELETE"].includes(
                          r.toUpperCase()
                        ),
                        children: "Body"
                      }
                    )
                  ] }),
                  /* @__PURE__ */ e.jsxs("div", { className: "flex gap-2 items-center", children: [
                    "Auth:",
                    /* @__PURE__ */ e.jsxs(
                      fe,
                      {
                        onValueChange: (a) => v("identity", a),
                        value: C.identity,
                        defaultValue: C.identity,
                        children: [
                          /* @__PURE__ */ e.jsx(xe, { className: "w-[180px] flex", children: _.isPending ? /* @__PURE__ */ e.jsx(ve, {}) : /* @__PURE__ */ e.jsx(ye, {}) }),
                          /* @__PURE__ */ e.jsxs(ge, { align: "center", children: [
                            /* @__PURE__ */ e.jsx(K, { value: J, children: "None" }),
                            (ue = _.data) == null ? void 0 : ue.map((a) => /* @__PURE__ */ e.jsx(K, { value: a.id, children: a.label }, a.id))
                          ] })
                        ]
                      }
                    )
                  ] })
                ] }),
                /* @__PURE__ */ e.jsx(V, { value: "headers", children: /* @__PURE__ */ e.jsx(qt, { control: j, register: g }) }),
                /* @__PURE__ */ e.jsxs(V, { value: "parameters", children: [
                  i.length > 0 && /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-4 my-4", children: [
                    /* @__PURE__ */ e.jsx("span", { className: "font-semibold", children: "Path Parameters" }),
                    /* @__PURE__ */ e.jsx(Rt, { control: j })
                  ] }),
                  l.length > 0 && /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-4 my-4", children: [
                    /* @__PURE__ */ e.jsx("span", { className: "font-semibold", children: "Query Parameters" }),
                    /* @__PURE__ */ e.jsx(Vt, { control: j, queryParams: l })
                  ] })
                ] }),
                /* @__PURE__ */ e.jsx(V, { value: "body", children: /* @__PURE__ */ e.jsx(
                  "textarea",
                  {
                    ...g("body"),
                    className: "border w-full rounded p-2 bg-muted h-40"
                  }
                ) })
              ]
            }
          )
        ] }),
        /* @__PURE__ */ e.jsx("div", { className: "min-w-0 p-8 bg-muted/70", children: p.error ? /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-2", children: [
          C.pathParams.some((a) => a.value === "") && /* @__PURE__ */ e.jsx(tt, { type: "caution", children: "Some path parameters are missing values. Please fill them in to ensure the request is sent correctly." }),
          /* @__PURE__ */ e.jsxs(ae, { children: [
            /* @__PURE__ */ e.jsx(nt, { children: /* @__PURE__ */ e.jsx(st, { children: "Request failed" }) }),
            /* @__PURE__ */ e.jsxs(rt, { children: [
              "Error:",
              " ",
              p.error.message || String(p.error) || "Unexpected error"
            ] })
          ] })
        ] }) : p.data ? /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-2", children: [
          /* @__PURE__ */ e.jsx("div", { className: "flex gap-2", children: /* @__PURE__ */ e.jsxs("div", { className: "flex text-xs gap-6", children: [
            /* @__PURE__ */ e.jsxs("div", { children: [
              "Status: ",
              p.data.status,
              " ",
              Bt[p.data.status] ?? ""
            ] }),
            /* @__PURE__ */ e.jsxs("div", { children: [
              "Time: ",
              p.data.time.toFixed(0),
              "ms"
            ] }),
            /* @__PURE__ */ e.jsxs("div", { children: [
              "Size: ",
              p.data.size,
              " B"
            ] })
          ] }) }),
          /* @__PURE__ */ e.jsxs(je, { defaultValue: "response", children: [
            /* @__PURE__ */ e.jsxs(be, { children: [
              /* @__PURE__ */ e.jsx(A, { value: "response", children: "Response" }),
              /* @__PURE__ */ e.jsx(A, { value: "headers", children: U.length ? `Headers (${U.length})` : "No headers" })
            ] }),
            /* @__PURE__ */ e.jsx(V, { value: "response", children: /* @__PURE__ */ e.jsx(
              Gt,
              {
                headers: p.data.headers,
                body: p.data.body
              }
            ) }),
            /* @__PURE__ */ e.jsx(V, { value: "headers", children: /* @__PURE__ */ e.jsxs(
              ae,
              {
                className: "max-h-[calc(83.333vh-140px)] overflow-y-auto grid grid-cols-2 w-full gap-2.5 font-mono text-xs shadow-none p-4",
                children: [
                  /* @__PURE__ */ e.jsx("div", { className: "font-semibold", children: "Key" }),
                  /* @__PURE__ */ e.jsx("div", { className: "font-semibold", children: "Value" }),
                  U.map(([a, f]) => /* @__PURE__ */ e.jsxs(Z, { children: [
                    /* @__PURE__ */ e.jsx("div", { children: a }),
                    /* @__PURE__ */ e.jsx("div", { className: "break-words", children: f })
                  ] }, a))
                ]
              }
            ) })
          ] })
        ] }) : /* @__PURE__ */ e.jsx("div", { className: "grid place-items-center h-full", children: /* @__PURE__ */ e.jsx("span", { className: "text-[16px] font-semibold text-muted-foreground", children: p.isPending ? /* @__PURE__ */ e.jsx(ve, {}) : "Send a request first to see the response here" }) }) })
      ] }) })
    }
  );
}, Ht = ({
  className: t,
  size: n = 16
}) => /* @__PURE__ */ e.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    className: t,
    width: n,
    height: n,
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fillRule: "evenodd",
        d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm14.024-.983a1.125 1.125 0 0 1 0 1.966l-5.603 3.113A1.125 1.125 0 0 1 9 15.113V8.887c0-.857.921-1.4 1.671-.983l5.603 3.113Z",
        clipRule: "evenodd"
      }
    )
  }
), Qt = (t) => {
  const [n, s] = Te(!1);
  return /* @__PURE__ */ e.jsxs(He, { onOpenChange: (r) => s(r), children: [
    /* @__PURE__ */ e.jsx(Qe, { asChild: !0, children: t.children ?? /* @__PURE__ */ e.jsxs("button", { className: "flex gap-1 items-center px-2 py-1 rounded-md bg-primary/80 hover:bg-primary transition text-primary-foreground text-xs", children: [
      "Test",
      /* @__PURE__ */ e.jsx(Ht, { className: "", size: 14 })
    ] }) }),
    /* @__PURE__ */ e.jsxs(
      Ue,
      {
        className: "max-w-screen-xl w-full h-5/6 overflow-auto p-0",
        "aria-describedby": void 0,
        children: [
          /* @__PURE__ */ e.jsx(Be, { children: /* @__PURE__ */ e.jsx(We, { children: "Playground" }) }),
          n && /* @__PURE__ */ e.jsx(Jt, { ...t })
        ]
      }
    )
  ] });
}, we = ft(`
  query GetCategories($input: JSON!, $type: SchemaType!) {
    schema(input: $input, type: $type) {
      url
      tags {
        __typename
        name
        operations {
          __typename
          slug
          deprecated
          method
          summary
          operationId
          path
        }
      }
    }
  }
`), Ut = {
  get: "green",
  post: "blue",
  put: "yellow",
  delete: "red",
  patch: "purple",
  options: "gray",
  head: "gray"
}, vn = (t) => {
  const n = Re(t.navigationId ?? "/reference"), s = new Ot(t);
  return {
    getHead: () => {
      if (t.type === "url" && !t.skipPreload)
        return /* @__PURE__ */ e.jsx(
          "link",
          {
            rel: "preload",
            href: t.input,
            as: "fetch",
            crossOrigin: "anonymous"
          }
        );
      if (t.server)
        return /* @__PURE__ */ e.jsx("link", { rel: "preconnect", href: t.server });
    },
    getMdxComponents: () => ({
      OpenPlaygroundButton: ({
        requireAuth: r,
        server: o,
        method: l,
        url: i,
        ...c
      }) => {
        var h;
        const u = Le(), d = Me({
          queryFn: () => s.fetch(we, {
            type: t.type,
            input: t.input
          }),
          enabled: !o,
          queryKey: ["playground-server"]
        });
        return r && !u.isAuthenticated ? /* @__PURE__ */ e.jsxs(
          E,
          {
            className: "gap-2 items-center",
            variant: "outline",
            onClick: u.login,
            children: [
              "Login to open in Playground ",
              /* @__PURE__ */ e.jsx(ze, { size: 16 })
            ]
          }
        ) : /* @__PURE__ */ e.jsx(
          Qt,
          {
            url: i ?? "/",
            method: l ?? "get",
            server: o ?? ((h = d.data) == null ? void 0 : h.schema.url) ?? "https://example.com",
            ...c,
            children: /* @__PURE__ */ e.jsxs(E, { className: "gap-2 items-center", variant: "outline", children: [
              "Open in Playground ",
              /* @__PURE__ */ e.jsx(Fe, { size: 16 })
            ] })
          }
        );
      }
    }),
    getSidebar: async (r) => {
      if (!lt({ path: n, end: !1 }, r))
        return [];
      try {
        const l = (await s.fetch(we, {
          type: t.type,
          input: t.input
        })).schema.tags.filter((i) => i.operations.length > 0).map((i) => ({
          type: "category",
          label: i.name || "Other endpoints",
          collapsible: !0,
          collapsed: !1,
          items: i.operations.map((c) => ({
            type: "link",
            label: c.summary ?? c.path,
            href: `#${c.slug}`,
            badge: {
              label: c.method,
              color: Ut[c.method.toLowerCase()]
            }
          }))
        }));
        return l.unshift({
          type: "link",
          label: "Overview",
          href: "#description"
        }), l;
      } catch {
        return [];
      }
    },
    getRoutes: () => [
      {
        async lazy() {
          const { OpenApiRoute: r } = await import("./Route-DlG_HTMu.js");
          return {
            element: /* @__PURE__ */ e.jsx(r, { client: s, config: t })
          };
        },
        children: [
          {
            path: n,
            children: [
              {
                index: !0,
                async lazy() {
                  const { OperationList: r } = await import("./OperationList-n4cxkna8.js");
                  return { element: /* @__PURE__ */ e.jsx(r, {}) };
                }
              }
            ]
          }
        ]
      }
    ]
  };
};
export {
  Pe as C,
  Qt as P,
  zt as S,
  ft as g,
  vn as o
};
//# sourceMappingURL=index-DVheR31u.js.map
